<script lang="ts">
  import { run } from 'svelte/legacy';

    import { onMount } from "svelte";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import { Booking, BOOKING_STATUS } from "../../model/Booking";
    import { getBrandIconPath, RemoveImageOnErrorCallback } from "../../utility/UiHelper";
    import BookingProgress from "../components/BookingProgress.svelte";
    import { DefaultErrorHandler } from "../../utility/ContextHelper.svelte";
    import BookingStatusBadge from "../components/BookingStatusBadge.svelte";
    import jQuery from "jquery";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    import PromisedComponentHandler from "../components/PromisedComponentHandler.svelte";
    import FilterToggleButton from "../components/FilterToggleButton.svelte";
    import { FilterAll, type FilterData } from "../components/FilterToggleButtonType.svelte";
    import { slide } from "svelte/transition";
    import type { Slot } from '../../model/Slot';
    import FilterField from '../components/FilterField.svelte';
    import { capitalizeFirstLetter } from '../../utility/helper';

    let bookings: Booking[] = $state([]);
    let bookingRequests: Booking[] = $state([]);

    let allBookingsAndRequests: (Booking)[] = $state([]);


    let cfgMng = ConfigurationManager.getInstance();

    let bookingManager = cfgMng.bookingController;

    onMount(() => {
        bookingManager.getAllBookings().then((incoming: Booking[]) => {
            bookings = incoming;
            bookings.sort((a: Booking, b: Booking) : number => {
                return a.name < b.name ? -1 : 1;
            });
        }).catch(DefaultErrorHandler);

        bookingManager.getBookingRequests().then((v: Booking[]) => {
            bookingRequests = v;
        }).catch(DefaultErrorHandler);
    });


    /**
     * Defines ascending vs descending order
     */
    let theOrder: number = $state(1);

    /**
     * The attribute to sort by based on the column head name
     */
    let sortBy: string = $state("name");

    let sortingIds: string[] = [
        "name",
        "customer",
        "slot",
        "status",
        "progress",
        "volume",
    ];

    /**
     * A map of column head names to actual attribute names of a booking or booking request
     */
    let mapSortingIdsToAttribute = {
        "name": "name",
        "customer": "brand",
        "slot": "slotId",
        "status": "status",
        "progress": "volumeSpent",
        "volume": "volumeTotal",
    };

    /**
     * Maps status to ordered numbers for sorting
     * */ 
    let statusOrderMap: Map<BOOKING_STATUS, number> = new Map([
        [BOOKING_STATUS.draft, 10],
        [BOOKING_STATUS.requested, 50],
        [BOOKING_STATUS.rejected, 70],
        [BOOKING_STATUS.canceled, 60],
        [BOOKING_STATUS.planned, 80],
        [BOOKING_STATUS.live, 100],
        [BOOKING_STATUS.aborted, 120],
        [BOOKING_STATUS.finished, 150]
    ]);

    /**
     * 
     * @param triggerParameter This parameter is only used to trigger the automatic svelta update once the parameter is updated
     */
    function updateSorting(triggerParameter: any) {
        // Get the actual attribute name from column head name
        let attirbuteName = mapSortingIdsToAttribute[sortBy];

        if(!attirbuteName) {
            return;
        }

        // Compare function for any attribute
        function defaultCompare(a: (Booking), b: (Booking)) : number {
            if(a[attirbuteName] < b[attirbuteName]) {
                return -1*theOrder;
            } else if(a[attirbuteName] > b[attirbuteName]) {
                return 1*theOrder;
            }
            return 0*theOrder;
        }

        function compareStatus(a: (Booking), b: (Booking)) : number {
            let va = statusOrderMap.get(a.status);
            let vb = statusOrderMap.get(b.status);
            if(va < vb) {
                return -1*theOrder;
            } else if(va > vb) {
                return 1*theOrder;
            }
            return 0*theOrder;
        }

        if(attirbuteName == "status") {
            allBookingsAndRequests = allBookingsAndRequests.sort(compareStatus);
        } else {
            allBookingsAndRequests = allBookingsAndRequests.sort(defaultCompare);
        }
    }



    function headerClicked(event: MouseEvent & { currentTarget: EventTarget & HTMLTableCellElement; }) {
        let clickedHeaderAttribute: string = jQuery(event.target).attr('id');

        if(sortBy == clickedHeaderAttribute) {
            theOrder *= -1;
        } else {
            sortBy = clickedHeaderAttribute;
            theOrder = 1;
        }

        updateSorting(null);
    }



    let filters: { [id: string]: FilterData<Booking>; } = $state(
        {
            "name": {
                id: "name",
                isOn: false,
                shouldBeInSet: (b: Booking, ref: string | string[]): boolean => {
                    return b.name.toLowerCase().indexOf((ref as string).toLowerCase()) >= 0;
                },
                text: "Name filter"
            } as FilterData<Booking>,
            "customer": {
                id: "customer",
                isOn: false,
                shouldBeInSet: (b: Booking, ref: string | string[]): boolean => {
                    return b.brand.toLowerCase().indexOf((ref as string).toLowerCase()) >= 0;
                },
                text: "Brand filter"
            } as FilterData<Booking>,
            "slot": {
                id: "slot",
                isOn: false,
                shouldBeInSet: (b: Booking, ref: string | string[]): boolean => {
                    let s: Slot = b.tryGetSlot();
                    if (s) {
                        return s.name.toLowerCase().indexOf((ref as string).toLowerCase()) >= 0;
                    } else {
                        return true;
                    }
                },
                text: "Slot filter"
            } as FilterData<Booking>,
            "status": {
                id: "status",
                shouldBeInSet:  (b: Booking, ref: string | string[]): boolean => {
                    return ref.indexOf(b.status.toLowerCase()) >= 0;
                },
                multiselect: true,
                currentFilterValue: [
                    "live", "paused", "requested"
                ],
                isOn: true,
                candidateCatalogue: [
                    BOOKING_STATUS.aborted, BOOKING_STATUS.canceled, BOOKING_STATUS.draft, BOOKING_STATUS.finished, BOOKING_STATUS.live, BOOKING_STATUS.paused, BOOKING_STATUS.planned, BOOKING_STATUS.rejected, BOOKING_STATUS.requested
                ]
            }
        });

    function filterUpdated(s) {
        allBookingsAndRequests = allBookingsAndRequests;
    }

    // Reactive merging of requests and bookings
    run(() => {
    allBookingsAndRequests = [...bookingRequests, ...bookings];
  });
    // Update sorting when list is updated
    run(() => {
    updateSorting(allBookingsAndRequests);
  });
    run(() => {
        const statuses = Object.values(filters).map((obj: FilterData<Booking>) => {
            obj.isOn
        });
        filterUpdated(statuses);
  });


</script>
<h1>All My Bookings</h1>
<div class="card  flex-fill w-100">
    <div class="card-header  card-header-space-between">
        <!-- Title -->
        <h2 class="card-header-title h4 text-uppercase">Bookings</h2>


        <!-- Dropdown -->
        <div class="dropdown">
            <a href="javascript: void(0);" class="dropdown-toggle no-arrow text-secondary" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="14" width="14"><g><circle cx="12" cy="3.25" r="3.25" style="fill: currentColor" /><circle cx="12" cy="12" r="3.25" style="fill: currentColor" /><circle cx="12" cy="20.75" r="3.25" style="fill: currentColor" /></g></svg>
            </a>
            <div class="dropdown-menu">
                <a href="javascript: void(0);" class="dropdown-item"> Export report </a>
                <a href="javascript: void(0);" class="dropdown-item"> Share </a>
                <a href="javascript: void(0);" class="dropdown-item"> Action </a>
            </div>
        </div>


    </div>


    <!-- Table -->
    <div class="table-responsive">

        <table id="bookingsTable" class="table align-middle table-edge table-nowrap mb-0">
            <thead class="thead-light">
                <tr>
                    {#each sortingIds as id, index}
                        <th id="{id}" class="{sortBy == id ? "bg-secondary  text-light" : ""} " style="font-size: 1.4m; cursor: pointer; vertical-align: top;" onclick={headerClicked}>
                            {capitalizeFirstLetter(id)} 
                            <BootstrapVectorIcon style="visibility: {sortBy == id ? "visible" : "hidden"}; width: 1.4em; height: 1.4em; float: right;" class="py-0 my-0 align-self-end" icon="{theOrder < 0 ? "sort-up" : "sort-down"}"></BootstrapVectorIcon>
                            {#if filters[id]}
                                <br />
                                <FilterField bind:filterData={filters[id]}></FilterField>
                            {/if}
                        </th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#if allBookingsAndRequests}
                    {#each FilterAll(allBookingsAndRequests, Object.values(filters)) as booking (booking.id)}
                        <tr transition:slide>
                            <td class="text-body-secondary">
                                {#if !booking.isPreLive()}
                                    <a href="#/booking/{booking.id}">{booking.name}</a>
                                {:else}
                                    <a href="#/bookingrequest/{booking.id}">{booking.name}</a>
                                {/if}
                            </td>

                            <td>
                                <span class="avatar avatar-xs me-2">
                                    <img alt="brand icon for {booking.brand}" src="{getBrandIconPath(booking.brand)}" class="avatar-img" onerror={RemoveImageOnErrorCallback}/>
                                </span>
                                {booking.brand}</td
                            >
                            <td>
                                <PromisedComponentHandler  retrievalPromise={booking.slot}>
                                    {#snippet children(s)}
                                        {s.name}
                                    {/snippet}
                                </PromisedComponentHandler>
                            </td>
                            <td>
                                <h3><BookingStatusBadge status={booking.status}></BookingStatusBadge></h3>
                            </td>
                            <td class="text-end">
                                {#if booking instanceof Booking}                                    
                                    <BookingProgress booking={booking}></BookingProgress>
                                {/if}
                            </td>
                            <td class="text-body-secondary font-monospace text-end">
                                {#if booking instanceof Booking}
                                    <PromisedComponentHandler  retrievalPromise={booking.earnings}>
                                        {#snippet children(earnings)}
                                        {earnings ? earnings.toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                          }) : 0} €
                                                                            {/snippet}
                                    </PromisedComponentHandler>
                                    <br />
                                {/if}
                                {booking.volumeTotal.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })} €
                            </td>
                        </tr>
                    {/each}
                {/if}

            </tbody>
        </table>
    </div>
    <!-- / .table-responsive -->

</div>
